<template>
	<div>
		<label><strong>Clients</strong></label>
		<v-select placeholder="Select a client" :options="clientList" v-model="$store.state.selectedClientList"
			:multiple="isMultiple" @input="inputChangeHandler" />
	</div>
</template>

<script>
import { storeData } from "../../store";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
	components: {
		vSelect,
	},
	props: {
		isMultiple: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
		};
	},
	computed: {
		clientList() {
			return storeData.clientList.filter((el) => el.label !== "All");
		},
	},
	watch: {
	},
	methods: {
		inputChangeHandler(val) {
			if (this.isMultiple) {
				this.$store.commit('set', ['selectedClientList', val]);
			}
			else {
				const selectedVal = !!val ? [val] : [];
				this.$store.commit('set', ['selectedClientList', selectedVal]);
			}
		}
	},
	beforeMount() {
	},
};
</script>

<style></style>